import {
  Alert,
  Button,
  Group,
  Stack,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { useSignupCompletion } from "../../hooks/useSignupCompletion";

function ProfileCompletionBanner() {
  const theme = useMantineTheme();
  const { userType } = useSignupCompletion();
  const isBrand = userType === "BRAND_USER";

  const message = isBrand
    ? "You're just a couple steps away from finding creators! Complete your brand profile to start collaborating."
    : "You're just a couple steps away from making money! Complete your profile to start collaborating with brands.";

  return (
    <Alert color="blue" radius={0} py={"xs"} mt={{ base: "sm", sm: 0 }}>
      <Stack gap="sm" hiddenFrom="sm">
        <Group align="flex-start" wrap="nowrap">
          <IconInfoCircle
            color={theme.colors.blue[6]}
            size="1.2rem"
            style={{ flexShrink: 0, marginTop: 2 }}
          />
          <Text fw={700} c={"blue"} size="sm">
            {message}
          </Text>
        </Group>
        <Button
          component={Link}
          to="/signup/complete"
          variant="light"
          color="blue"
          size="sm"
          fullWidth
        >
          Continue Setup
        </Button>
      </Stack>

      <Group justify="space-between" visibleFrom="sm">
        <Group align="flex-start" wrap="nowrap">
          <IconInfoCircle
            color={theme.colors.blue[6]}
            size="1.2rem"
            style={{ flexShrink: 0, marginTop: 2 }}
          />
          <Text fw={700} c={"blue"} size="sm">
            {message}
          </Text>
        </Group>
        <Button
          component={Link}
          to="/signup/complete"
          variant="light"
          color="blue"
          size="sm"
          style={{ flexShrink: 0 }}
        >
          Continue Setup
        </Button>
      </Group>
    </Alert>
  );
}

export default ProfileCompletionBanner;
